export const getActivityRequestConfig = () => {
  const jwtToken = localStorage.getItem('jwtToken');
  return {
    ...(jwtToken ? { headers: { Authorization: 'Bearer ' + jwtToken } } : {}),
    withCredentials: true
  };
};
